// extracted by mini-css-extract-plugin
export default {"default-error-boundary":"bhmUT_I0gYReNJdegkAi","oops-emoji":"tzDNWLFqS4pCmH3rEtDF","error-stack":"T9JxhCf6leHDu6J7mKoq"};